import { AccountState, RootState, Account } from '@/types';
import { GetterTree, MutationTree, ActionTree, Module } from 'vuex';
import AccountService from '@/services/account.service';
import router from '../../router';
import store from '../store';
import EventBus from '../../services/eventbus.service';

type AccountGetter = GetterTree<AccountState, RootState>;

export const initialState = (): AccountState => {
  return {
    initialState,
    accounts: [],
    activeAccountId: null,
  };
};

export const getters: AccountGetter = {
  accounts: (state) => state,
  activeAccount: (state) => state.accounts.filter((item: Account) =>
    item.id === state.activeAccountId),
  activeAccountId: (state) => state.activeAccountId,
};

export const mutations: MutationTree<AccountState> = {
  addAccounts(state, accs) {
    state.accounts = accs;
  },
  selectAccount(state, id) {
    state.activeAccountId = Number(id);
  },
  clearAccount(state) {
    state.activeAccountId = null;
  },
};

export const actions: ActionTree<AccountState, RootState> = {
  async addAccountsAsync(context) {
    const accs = await AccountService.getUserAccounts();
    context.commit('addAccounts', accs);
  },
  async changeAccountAsync(context: any, params: {accountId: number, forceRender: boolean, currentRouteAccountId: number}) {
    const accountId = params.accountId;
    context.commit('selectAccount', accountId);
    if (accountId !== params.currentRouteAccountId) {
      EventBus.$emit('global-account-change', {type: 'account', id: accountId, forceRender: params.forceRender});
    }
  },
};

export const accounts: Module<AccountState, RootState> = {
  state: initialState(),
  getters,
  mutations,
  actions,
};
